export enum CustomValidationExceptionEnum {
  QuoteClosed = 1,
  ActiveEnduranceContract = 2,
  InvalidSelectedPlan = 3,
  ActiveDealershipContract = 4,
  RewriteDisabled = 5,
  ActivationFeeOverpaid = 6,
  DownPaymentOverpaid = 7,
  AchPaymentMethodNotAllowed = 8,
  ConsumerIdNull = 9,
  // Note: Value 10 is intentionally skipped to maintain compatibility with backend error codes
  NoChangesMadeRequiringRewrite = 11,
  EcommerceRewriteRequired = 12,
  // Note: Value 13 (PolicyHolderNotSupportedForAdmin) is not handled by a custom modal
  VinUpdateChangesVehicle = 14,
}

export const CustomErrorEnumDisplayName = {
  [CustomValidationExceptionEnum.QuoteClosed]: 'Closed Quote',
  [CustomValidationExceptionEnum.ActiveEnduranceContract]: 'Active Endurance Contract',
  [CustomValidationExceptionEnum.InvalidSelectedPlan]: 'Invalid Selected Plan',
  [CustomValidationExceptionEnum.ActiveDealershipContract]: 'Active Dealership Contract',
  [CustomValidationExceptionEnum.RewriteDisabled]: 'Coverage sold under 30 / 60 days',
  [CustomValidationExceptionEnum.ActivationFeeOverpaid]: 'Elite Club removed',
  [CustomValidationExceptionEnum.DownPaymentOverpaid]: 'Down Payment altered',
  [CustomValidationExceptionEnum.AchPaymentMethodNotAllowed]: 'ACH payment method not allowed',
  [CustomValidationExceptionEnum.ConsumerIdNull]: 'Consumer Id is null please wait and try again',
  [CustomValidationExceptionEnum.NoChangesMadeRequiringRewrite]:
    'Rewrite not allowed until changes are made',
  [CustomValidationExceptionEnum.EcommerceRewriteRequired]: 'Rewrite required',
  [CustomValidationExceptionEnum.VinUpdateChangesVehicle]: 'VIN update changes vehicle',
};
